import React, { useEffect, useRef } from 'react';
import Swal from 'sweetalert2';
import { Provider } from 'react-redux';
import withReactContent from 'sweetalert2-react-content';
import store from "../../redux/store/store.js";
import Request from '../../utilities/Request.jsx';

const MyModal = withReactContent(Swal);
export default function SweetAlert({
	                                   isOpen = true,
	                                   children,
	                                   icon = '',/** success, error, warning, info, question */
	                                   header,
	                                   onCancel,
	                                   confirmedIcon = 'success',
	                                   confirmedText,
	                                   confirmedTitle = 'Success',
	                                   onConfirm,
	                                   showCancelButton = false,
	                                   showConfirmButton = false,
	                                   confirmButtonText = 'Yes',
	                                   scrollbarPadding = false,
                                   }) {
	const onConfirmReference = useRef(onConfirm);

	useEffect(() => {
		onConfirmReference.current = onConfirm;
	}, [onConfirm]);

	useEffect(() => {
		if(isOpen) {
			MyModal.fire({
				title: header,
				html: <Provider
					store={store}
				>
					{children}
				</Provider>,
				icon,
				scrollbarPadding,
				showCancelButton,
				showConfirmButton,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: confirmButtonText,
				showLoaderOnConfirm: true,
				preConfirm: () => {
					const onConfirm = onConfirmReference.current;
					if(onConfirm) {
						return Promise.resolve(onConfirm())
							.catch(async(error) => {
								error = await Request.parseError(error);
								return {
									error: error
								};
							});
					}
				},
				allowOutsideClick: () => !MyModal.isLoading()
			}).then((result) => {
				if(result.isConfirmed) {
					if(result.value && result.value.error) {
						MyModal.fire({
								title: 'Error',
								html: result.value.error,
								icon: 'error',
							}
						);
						onCancel && onCancel();
						return;
					} else {
						if(confirmedText) {
							MyModal.fire({
									title: confirmedTitle,
									html: confirmedText,
									icon: confirmedIcon,
								}
							);
							return;
						}
					}
				}
				onCancel && onCancel();
			});
			return () => {
				Swal.close();
			};
		}
	}, [isOpen]);


	return <div />;
}
SweetAlert.icons = {
	warning: 'warning',
	success: 'success',
};
SweetAlert.direct = MyModal;